/**
 * External URL helpers for Amazon internal tools.
 * Centralised here so URL changes only require a single edit.
 */

/** Badge photo URL — returns a headshot image for the given login/alias */
export const badgePhotoUrl = (login: string): string =>
  `https://badgephotos.corp.amazon.com/?login=${login}`;

/** Phone Tool profile URL — links to the employee directory page for the given login/alias */
export const phoneToolUrl = (login: string): string =>
  `https://atoz.amazon.work/phonetool/users/${login}`;
